import React from 'react';
import { SDialog } from './styles';

export default function Dialog(props) {
  return <SDialog disableScrollLock {...props} />;
}
